import React from 'react';
import NumberFormat from "react-number-format";

export class Scale extends React.Component {
    render() {
        return (
            <div className="scaleWrapper order-2">
                <div className="scaleHeadline">Neuinfektionen<br className="mobile-0" /> in den letzten<br className="mobile-0" /> 7 Tagen<br className="mobile-0" /> pro 100.000<br className="mobile-0" /> Einwohner</div>
                <div className="w-100 position-relative scaleInner">
                    <div
                        className="scale"
                        style={
                            window.innerWidth < 750
                            ? {background: "linear-gradient(to left, rgb(55, 17, 25), rgb(199, 74, 101) " + (100 - 5000 / this.props.max_value).toString() + "%, rgb(255, 248, 212))"}
                            : {background: "linear-gradient(to bottom, rgb(55, 17, 25), rgb(199, 74, 101) " + (100 - 5000 / this.props.max_value).toString() + "%, rgb(255, 248, 212))"}
                        }
                    />
                    <div
                        className="scaleGrenzwert"
                        style={
                            window.innerWidth < 750
                            ? {left: (50 * 100 / this.props.max_value).toString() + '%'}
                            : {bottom: (50 * 100 / this.props.max_value).toString() + '%'}
                        }
                    >
                        <div className="line" />
                        <div>50</div>
                    </div>
                    {this.props.kreis &&
                        <div
                            className="scalePointer"
                            style={
                                window.innerWidth < 750
                                ? {left: (this.props.kreis[this.props.selected_date].inzidenz * 100 / this.props.max_value).toString() + '%'}
                                : {bottom: (this.props.kreis[this.props.selected_date].inzidenz * 100 / this.props.max_value).toString() + '%'}
                            }
                        >
                            <div className="turn-90deg scaleArrow">❯</div>
                            <div>
                                <NumberFormat
                                    value={this.props.kreis[this.props.selected_date].inzidenz}
                                    decimalScale={1}
                                    fixedDecimalScale={true}
                                    displayType={'text'}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                />
                            </div>
                        </div>
                    }
                    <div className="d-flex scaleWerte" style={{marginTop: "2px"}}>
                        <div className="mr-auto">0</div>
                        <div>{Math.ceil(this.props.max_value / 10) * 10}</div>
                    </div>
                </div>
            </div>
        )
    }
}